<template lang="pug">
  article.showroom.min-h-screen.pt-90.md-pt-120.px-15
    main-el
      template(v-if="doc")
        //- sections...
        template(v-for="section in doc.acf.showroom_sections")
          //- (text section)
          template(v-if="section.acf_fc_layout === 'about'")
            section.showroom__intro.mx-auto.max-w-610.text-18.children-mt-em.mb-100(v-html="section.text")

          //- (products section)
          template(v-else-if="section.acf_fc_layout === 'products'")
            section.mt-100.md-mb-50.md-flex.flex-wrap.justify-center.overflow-x-hidden
              //- products...
              template(v-for="(row, i) in section.products")
                //- product
                product-thumb-full.w-full.md-w-5x12.md-px-40.lg-px-75.xl-px-100.mb-110(v-if="item(row.product)", :doc="item(row.product)", :no="no(row.product)", :key="no(row.product)", :purchasable="row.disable_purchase_hide_price !== true", :shippingLink="false", :detailsModal="row.enable_details_sizing_modal === true", :priceHidden="!row.price_visible")
                //- fetch product via failed <img>
                img.invisible.min-h-screen(v-else, src="fail", @error="fetchProduct(row.product)")

      //- not found
      template(v-if="doc === undefined")
        header.text-center.text-24 Not Found
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
// import get from 'lodash/get'
import ProductThumbFull from '@/components/Shop/ProductThumbFull'
import { optimImgSize } from '@/utils'
export default {
  name: 'Showroom',
  props: ['showroom'],
  data () {
    return {
      doc: undefined,
      products: []
    }
  },
  computed: {
    ...mapState(['winW']),

    productRows () {
      let items = []
      if (this.doc) {
        items = this.doc.acf.showroom_sections.reduce((acc, sec) => {
          if (sec.acf_fc_layout === 'products') {
            acc = acc.concat(sec.products.map(row => row.product))
          }
          return acc
        }, [])
      }
      return items
    }
  },
  methods: {
    async fetchDoc () {
      try {
        let docs = await fetch(Vue.config.WP.API + '/showrooms/?slug=' + this.showroom)
        docs = await docs.json()
        this.doc = docs[0]
      } catch (e) {
        console.error(e)
      }
    },
    async fetchProduct ({ post_name }) {
      try {
        let w = this.winW
        w = w >= 768 ? w * 5 / 12 : w * 2
        const doc = await this.$store.dispatch('shop/getProduct', { showroom: true, handle: post_name, imgMaxW: optimImgSize(w) })
        if (!doc) return console.warn('Showroom: Product Not Found:', post_name)
        this.products.push(doc)
      } catch (e) {
        console.error(e)
      }
    },
    item ({ post_name }) {
      return this.products.find(prd => prd.handle === post_name)
    },
    no ({ post_name }) {
      return this.productRows.findIndex(prd => prd.post_name === post_name) + 1
    }
  },
  created () {
    this.fetchDoc()
  },
  metaInfo: {
    meta: [
      { name: 'robots', content: 'noindex,nofollow' }
    ]
  },
  components: { ProductThumbFull }
}
</script>

<style>
@import '../../style/_settings.css';
.showroom__intro{
  & :--heading{
    margin-bottom: 2.8em;
    text-align: center;
  }
}

@media (--bkpt-md) {
  .showroom__intro{
    & :--heading{
      font-size: calc(24/18 * 1em);
      margin-bottom: calc(47/24 * 1em);
    }
  }
}
</style>
